import React from "react";
import styled from "styled-components";
import settings from "../../settings";
import trimLeading from "@src/utils/trimLeading";
import { Props } from "./";
import { down } from "styled-breakpoints";

export const Frame = styled.div<{
	align?: Props["align"];
	color?: Props["color"];
}>`
	display: flex;
	flex-direction: column;
	align-items: ${(props) => (props.align == "left" ? "flex-start" : "center")};
	color: ${(props) => (props.color ? props.color : settings.color.main)};
	padding-bottom: 8px;
	${down("xs")} {
		padding-bottom: 1px;
	}
`;

export const Title = styled.h3<{ align?: Props["align"] }>`
	font-weight: 700;
	font-family: ${settings.font.en};
	letter-spacing: 4.07px;
	text-align: ${(props) => (props.align == "left" ? "left" : "center")};
	${trimLeading({ fontSize: 37, lineHeight: 37, font: "montserrat" })}
	${down("xs")} {
		${trimLeading({ fontSize: 32, lineHeight: 32, font: "montserrat" })}
	}
`;

export const SubTitle = styled.p<{ align?: Props["align"] }>`
	font-weight: 500;
	font-family: ${settings.font.jp};
	letter-spacing: 2px;
	text-align: ${(props) => (props.align == "left" ? "left" : "center")};
	${trimLeading({ fontSize: 18, lineHeight: 18 })}
	${Title} + & {
		margin-top: 20px;
	}
	${down("xs")} {
		${trimLeading({ fontSize: 16, lineHeight: 16 })}
		${Title} + & {
			margin-top: 17px;
		}
	}
`;
